// extracted by mini-css-extract-plugin
module.exports = {"login":"style_login__2aHrb","title":"style_title__1S7mi","block":"style_block__3Mpmx","inner":"style_inner__36l5h","form":"style_form__2Xx95"};